export class LocalStorageKeys {
  static brand_access_token = "brand_access_token";
  static brand_temporary_access_token = "brand_temporary_access_token";
  static user_data = "user_data";
  static agency_data = "agency_data";
  static agent_data = "agent_data";
  static admin_data = "admin_data";
  static registration_data = "registration_data";
  // static mylo_user_access_token = "mylo_user_access_token";
  // static mylo_user_question_id ="mylo_user_question_id"
}

export class QuestionStatus {
  static DRAFT = "draft";
  static FINALIZED = "finalized";
  static PENDING = "pending";
  static INCOMING = "incoming";
  static ACCEPTED = "accepted";
  static ACTIVE = "active";
  static REJECTED = "rejected";
  static UNANSWERED = "unanswered";
  static INAPPROPRIATE = "INAPPROPRIATE";
  static CANCELLED = "cancelled";
}
